import PropTypes from 'prop-types'
import CustomButton from './CustomButton'

const ButtonIcon = ({ btnTitle, icon, btnTitleProps, btnProps, outline = true, children, testId = 'button-icon' }) => {
  return (
    <CustomButton
      color="primary"
      outline={outline}
      className="flex-centered w-100"
      testId={testId}
      {...btnProps}
    >
      {icon && <span className="me-2">{icon}</span>}
      <span className="fw-medium" {...btnTitleProps}>
        {btnTitle}
      </span>
      {children && children}
    </CustomButton>
  )
}

ButtonIcon.propTypes = {
  btnTitle: PropTypes.string,
  icon: PropTypes.object,
  children: PropTypes.node,
}

export default ButtonIcon
